import { diContainer } from "./CuffLink";

/**
 * This function checks if a service has already been bound and unbinds if necessary, before binding it to a new constant value.
 * This prevents multiple bindings to the same service.
 *
 * This function is NOT intended to be used in production code
 * This function is intended to be used for scenarios where the same service may need to be bound multiple times
 * Example use cases: Storybook and tests
 *
 * @param serviceIdentifier to be bound
 * @param value to be bound to identifier
 */
export function bindOrRebindToConstantValue(serviceIdentifier, value) {
  if (diContainer.isBound(serviceIdentifier)) {
    diContainer.unbind(serviceIdentifier);
  }
  diContainer.bind(serviceIdentifier).toConstantValue(value);
}
//# sourceMappingURL=bindOrRebind.js.map